<template>
	<div class="products-list">
		<b-loading :is-full-page="true" :active.sync="isLoading" :can-cancel="false"></b-loading>
		<h3>Check Products</h3>

		<div class="productExport">
			<input type="file" @change="loadTextFromFile" />
		</div>

		{{ progress }} of {{ product_total }}

		<div>
			<ul>
				<li v-for="(error, index) in errors" :key="index" class="update-error">
					{{ error }}
				</li>
			</ul>
		</div>
		<!-- <div v-if="progress > 0" class="progress-bar">
			<br /><br />
			<b-progress :value="Math.ceil(progress)" show-value format="percent" type="is-success" size="is-medium"></b-progress>
		</div> -->
	</div>
</template>

<script>
// @ is an alias to /src

export default {
	name: 'productsList',
	data: function() {
		return {
			isLoading: false,
			progress: 0,
			product_total: 0,
			errors: []
		}
	},

	mounted: async function() {},

	computed: {},

	methods: {
		async loadTextFromFile(ev) {
			this.isLoading = true
			const file = ev.target.files[0]
			const reader = new FileReader()

			reader.onload = async event => {
				var raw = event.target.result.split(/\r?\n/)

				var header = raw[0].split(/,/)

				let bd_code_index = header.indexOf('BD CODE')
				// let barcode_index = header.indexOf('BARCODE')
				let selling_price_index = header.indexOf('SELLING PRICE')

				// barcode_index == -1 ||

				if (bd_code_index == -1 || selling_price_index == -1) {
					this.$swal.fire('Missing header!')

					this.isLoading = false

					return
				}

				// Remove first row
				raw.shift()

				this.product_total = raw.length - 1

				// Loop every row to put it in array
				for (let products of raw) {
					// var splitData = data.split(/,/)
					var splitData = products.match(/(".*?"|[^",\s]+)(?=\s*,|\s*$)/g)

					if (splitData[bd_code_index]) {
						this.progress++

						const bd_code = splitData[bd_code_index]
						const price = splitData[selling_price_index].replace(/['"]+/g, '')
						// const barcode = splitData[barcode_index]

						// remove commas
						const cleanPrice = price.replaceAll(',', '')

						let data = {
							bd_code,
							limit: 1
						}

						let apiGetProduct = await this.$api.searchProduct({ data })

						if (!apiGetProduct || apiGetProduct.data.total < 1) {
							this.errors.push(bd_code + ' is missing.')
						} else if (Number(apiGetProduct.data.list[0].price) !== Number(cleanPrice)) {
							console.log(bd_code, Number(apiGetProduct.data.list[0].price), Number(cleanPrice))
							this.errors.push(bd_code + "'s price does not match.")
						}
						// else if (String(apiGetProduct.data.list[0].barcode) !== String(barcode)) {
						// 	console.log(bd_code, String(apiGetProduct.data.list[0].barcode), String(barcode))
						// 	this.errors.push(bd_code + "'s barcode does not match.")
						// }

						// let data = { bd_code, price }

						// const apiUpdateProduct = await this.$api.productUpdate(data)

						// if (!apiUpdateProduct) {
						// 	this.errors.push('Error Updating ' + bd_code)
						// }
					}
				}

				this.isLoading = false
			}

			reader.readAsText(file)
			this.isLoading = false
		}
	}
}
</script>

<style scoped>
@import '../styles/ProductsList.css';
</style>
